import { isValidElement, type ReactNode } from "react";

/** The text a React node renders, without markup (links keep their text). */
export function reactText(node: ReactNode): string {
  if (node == null || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(reactText).join("");
  if (isValidElement<{ children?: ReactNode }>(node)) return reactText(node.props.children);
  return "";
}
